import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class MenuItemService extends RestfulService<Models.MenuItem> {

  constructor(private restService: RestService) {
    super(Models.MenuItem);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('menu-items');
  }

}
